import React from "react";
import { useForceDarkTheme } from "../hooks/useForceDarkTheme";

export default function PrivacyPolicy() {
  useForceDarkTheme();
  return (
    <div className="min-h-screen bg-black text-gray-200 px-6 py-16">
      <div className="max-w-3xl mx-auto space-y-6">
        <h1 className="text-4xl font-bold text-white">Política de Privacidad</h1>
        <p className="text-sm text-gray-400">Última actualización: 24 de febrero de 2026</p>

        <section className="space-y-3">
          <h2 className="text-2xl font-semibold text-white">1. Quiénes somos</h2>
          <p>
            JG Models (&quot;nosotros&quot;, &quot;nuestro CRM&quot;) es una agencia de gestión de creadoras de contenido digital. Operamos el sitio
            web <a className="text-pink-400" href="https://jgmodels.com">jgmodels.com</a> y el CRM interno asociado para la
            administración de modelos, chatters y operaciones internas.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-2xl font-semibold text-white">2. Datos que recolectamos</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>Datos de cuenta de usuarios autorizados (nombre, email, rol, contraseña hash).</li>
            <li>Datos operativos: turnos, reportes diarios, comisiones, asignaciones de modelos.</li>
            <li>Datos públicos de Instagram obtenidos vía API oficial de Meta (Instagram Graph API), únicamente
              de cuentas Business/Creator cuyas administradoras autorizaron expresamente la conexión:
              followers_count, media_count, insights de publicaciones, demografía de audiencia agregada.</li>
            <li>Datos de clientes/fans recolectados manualmente por chatters dentro del módulo CRM (username,
              monto gastado, preferencias).</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-2xl font-semibold text-white">3. Uso de los datos</h2>
          <p>Usamos esta información estrictamente para:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Operar el CRM interno (asignaciones, reportes, contabilidad, metas).</li>
            <li>Auditoría de cuentas de Instagram de las modelos representadas (con su autorización).</li>
            <li>Métricas internas de desempeño de chatters y modelos.</li>
            <li>Comunicación operativa entre el equipo.</li>
          </ul>
          <p>
            <strong>No vendemos, alquilamos ni cedemos datos a terceros.</strong> Los datos obtenidos vía Instagram
            Graph API se almacenan únicamente para análisis interno y se eliminan si la modelo retira su consentimiento.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-2xl font-semibold text-white">4. Permisos solicitados a Meta/Instagram</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li><code>instagram_basic</code> — leer info básica de la cuenta.</li>
            <li><code>instagram_manage_insights</code> — leer métricas de publicaciones y audiencia.</li>
            <li><code>pages_show_list</code> — listar páginas de Facebook administradas.</li>
            <li><code>pages_read_engagement</code> — leer engagement de la página vinculada.</li>
            <li><code>business_management</code> — gestionar el portfolio de cuentas de las modelos.</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-2xl font-semibold text-white">5. Almacenamiento y seguridad</h2>
          <p>
            Todos los datos se almacenan en bases de datos cifradas en reposo, accesibles solo por roles autorizados
            (CEO, administrativo, asistente). Las contraseñas se almacenan como hash bcrypt. Los tokens de acceso
            a Meta se guardan exclusivamente en el backend, nunca en el cliente, y se renuevan automáticamente
            antes de su expiración (60 días).
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-2xl font-semibold text-white">6. Tus derechos</h2>
          <p>
            Cualquier modelo, chatter o titular de datos puede solicitar acceso, rectificación o eliminación de su
            información escribiendo a: <a className="text-pink-400" href="mailto:privacy@jgmodels.com">privacy@jgmodels.com</a>.
            Procesamos la solicitud en un máximo de 7 días hábiles.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-2xl font-semibold text-white">7. Eliminación de datos (Data Deletion)</h2>
          <p>
            Para eliminar tus datos asociados a la integración con Meta/Instagram, envía un email a
            <a className="text-pink-400" href="mailto:privacy@jgmodels.com"> privacy@jgmodels.com</a> con el asunto
            <em> &quot;Solicitud de eliminación de datos&quot;</em>. Confirmaremos por email en 48 horas y eliminaremos los
            datos en un plazo de 30 días.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-2xl font-semibold text-white">8. Cambios a esta política</h2>
          <p>
            Podemos actualizar esta política. Cualquier cambio sustancial será notificado a los usuarios activos del CRM
            con al menos 7 días de anticipación.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-2xl font-semibold text-white">9. Contacto</h2>
          <p>
            JG Models — <a className="text-pink-400" href="mailto:contacto@jgmodels.com">contacto@jgmodels.com</a>
          </p>
        </section>
      </div>
    </div>
  );
}
